module.exports = __webpack_public_path__ + "static/media/ic_blank.fb723716.png";